export default {"src":"/_next/static/media/sy.639a0bb5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};